import React from "react";

const Heading = () => {
  return (
    <header className="App-header">
      <img
        className="App-logo"
        src="https://i1.wp.com/cyf.com/wp-content/uploads/2017/07/CYF_Thumb.png?fit=512%2C512&ssl=1"
        alt="logo"
      />
      CYF Hotel
    </header>
  );
};

export default Heading;
